import { extractHtmlError, fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { ProjectGroupFormViewModel } from "../types";

export default function ProjectGroupFormApp(props: ProjectGroupFormViewModel) {
  const [name, setName] = useState(props.values.name);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting || !props.canEdit) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("Id", String(props.values.id));
      formData.append("Name", name);
      formData.append("saveAndClose", "false");

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      const html = await response.text();
      if (!response.ok) {
        throw new Error(html);
      }

      const validationMessage = extractHtmlError(html);
      if (validationMessage) {
        setErrorMessage(validationMessage);
        return;
      }

      window.location.reload();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Ulozeni se nepodarilo.";
      setErrorMessage(message.includes("<") ? extractHtmlError(message) || message : message);
    } finally {
      setIsSubmitting(false);
    }
  }

  const disabled = !props.canEdit || isSubmitting;

  return (
    <div className="forms-app project-group-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="base-form">
        <div className="form-group">
          <label htmlFor="project-group-name">{props.labels.name}</label>
          <input
            id="project-group-name"
            className="form-control"
            value={name}
            disabled={disabled}
            onChange={(event) => {
              setName(event.currentTarget.value);
              setErrorMessage(null);
            }}
          />
        </div>
        <hr />
        {props.isEdit ? (
          <div className="form-group">
            <label htmlFor="project-group-id">{props.labels.id}</label>
            <input id="project-group-id" className="form-control" value={props.values.id} disabled />
          </div>
        ) : null}
      </div>
      <div className="panel-footer">
        <button
          type="button"
          className="btn btn-success btn-sm"
          disabled={disabled}
          onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
        >
          <em className="fa fa-save"></em>
          {isSubmitting ? `${props.submitText}...` : props.submitText}
        </button>
      </div>
    </div>
  );
}
